import React from 'react';

import styles from './OfflineMode.module.scss';
import { confirmationCopy } from './copy';
import Modal from 'admin/shared-components/Modal/Modal';
import type { OfflineModeDirection } from 'redux-stores/offlineMode';

export const confirmActionLabel = (direction: OfflineModeDirection): string =>
  direction === 'activate' ? 'Confirm activation of Offline Mode' : 'Confirm return to Cloud Mode';

export const CANCEL_ACTION_LABEL = 'Cancel and leave Offline Mode unchanged';

export type OfflineModeConfirmationProps = {
  isOpen: boolean;
  direction: OfflineModeDirection;
  organizationName: string;
  isSwitching: boolean;
  onConfirm: () => Promise<void> | void;
  onCancel: () => void;
  reachSummary?: React.ReactNode;
};

export default function OfflineModeConfirmation({
  isOpen,
  direction,
  organizationName,
  isSwitching,
  onConfirm,
  onCancel,
  reachSummary,
}: OfflineModeConfirmationProps) {
  const copy = confirmationCopy(direction, organizationName);

  return (
    <Modal
      body={
        <div className={styles.confirmationPlain} data-test-id="offlineModeConfirmation">
          {copy.paragraphs.map((paragraph) => (
            <p className={styles.confirmationBody} key={paragraph}>
              {paragraph}
            </p>
          ))}

          {reachSummary ? (
            <div className={styles.confirmationReach} data-test-id="offlineModeConfirmationReach">
              {reachSummary}
            </div>
          ) : null}

          {copy.notice ? (
            <p
              className={styles.confirmationNotice}
              data-test-id="offlineModeConfirmationNotice"
              role="note"
            >
              {copy.notice}
            </p>
          ) : null}
        </div>
      }
      canClose={!isSwitching}
      closeButton={copy.cancelLabel}
      closeTestId={CANCEL_ACTION_LABEL}
      doneButton={isSwitching ? copy.confirmInFlightLabel : copy.confirmLabel}
      doneDisabled={isSwitching}
      doneTestId={confirmActionLabel(direction)}
      header={copy.title}
      isOpen={isOpen}
      isWarningButtonPresent
      modalSize="medium"
      onClose={onCancel}
      onSuccess={onConfirm}
    />
  );
}
